module.exports = __webpack_public_path__ + "static/media/medium_logo.2cbd5ba3.svg";